export default "__VITE_ASSET__sgTvo2mI__"